// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-jhysLstd-index-main_right_content-144_Y","table":"components-swbl-jhysLstd-index-table-1zD1o"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/jhysLstd/index.css
// module id = 2297
// module chunks = 0